import { postApi } from '../api/userProfileManager';
export default async (body, logger) => {
    await postApi(body, `profile/{userId}`, logger);
};
